import { FC } from 'react';

import { Box, Typography } from '@mui/material';

import { SubHeading } from 'src/components';

import { CountryDisplay } from '../CountryDisplay';
import { TextDisplay } from '../TextDisplay';

interface AddressDisplay {
    eirCode: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    county: string;
    country: string;
    heading: string;
    postalLabel: string;
    timeAtAddress?: {
        years: number;
        months: number;
    };
}

const AddressDisplay: FC<AddressDisplay> = ({
    eirCode,
    addressLine1,
    addressLine2,
    city,
    county,
    country,
    heading,
    postalLabel,
    timeAtAddress,
}) => {
    return (
        <Box display="flex" flexDirection="column" gap="24px">
            <SubHeading subHeading={heading} />
            <TextDisplay label={postalLabel} value={eirCode} />
            <Box width="100%" display="flex" justifyContent="space-between">
                <TextDisplay label="Address Line 1" value={addressLine1} />
                <TextDisplay label="Address Line 2" value={addressLine2} />
            </Box>
            <Box width="100%" display="flex" justifyContent="space-between">
                <TextDisplay label="Town/City" value={city} />
                <TextDisplay label="County" value={county} />
            </Box>

            <Box width="100%" display="flex" justifyContent="space-between">
                <CountryDisplay label="Country" country={country} value={country} />
                {timeAtAddress && (
                    <TextDisplay
                        label="Time at Address"
                        value={
                            <Box display="flex" alignItems="center" gap="16px">
                                <Typography
                                    fontSize="16px"
                                    color="#686867"
                                    fontWeight="400"
                                    lineHeight="24px"
                                >
                                    {timeAtAddress?.years}
                                </Typography>
                                <Typography
                                    fontSize="14px"
                                    color="#686867"
                                    fontWeight="400"
                                    lineHeight="21px"
                                >
                                    Years
                                </Typography>
                                <Typography
                                    fontSize="16px"
                                    color="#686867"
                                    fontWeight="400"
                                    lineHeight="24px"
                                >
                                    {timeAtAddress?.months}
                                </Typography>
                                <Typography
                                    fontSize="14px"
                                    color="#686867"
                                    fontWeight="400"
                                    lineHeight="21px"
                                >
                                    Months
                                </Typography>
                            </Box>
                        }
                    />
                )}
            </Box>
        </Box>
    );
};

export default AddressDisplay;
